<template>
    <div class="total-employee px-3 py-3">
        <div class="header-total-employee locale-font">
            {{$vuetify.lang.t('$vuetify.totalEmployeeGraph.totalEmployees')}}
        </div>

        <bar-chart
            v-if="show"
            :options="optionsBarCollection"
            :chart-data="dataBarCollection"
        ></bar-chart>
    </div>
</template>

<script>
import BarChart from '@/components/Chart/BarChart.js'
export default {
    name: 'TotalEmployeeGraph',

    components: {
        BarChart
    },

    computed: {
        days () {
            return [
                this.$vuetify.lang.t('$vuetify.totalEmployeeGraph.mon'),
                this.$vuetify.lang.t('$vuetify.totalEmployeeGraph.tues'),
                this.$vuetify.lang.t('$vuetify.totalEmployeeGraph.wednes'),
                this.$vuetify.lang.t('$vuetify.totalEmployeeGraph.thurs'),
                this.$vuetify.lang.t('$vuetify.totalEmployeeGraph.fri'),
                this.$vuetify.lang.t('$vuetify.totalEmployeeGraph.satur'),
                this.$vuetify.lang.t('$vuetify.totalEmployeeGraph.sun')
            ]
        },
        dataBarCollection () {
            return this.initializeBarData()
        }
    },
    data () {
        return {
            show: false,
            branchId: null,
            optionsBarCollection: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            min: 0
                        }
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            },
            presentData: [],
            lateData: []
        }
    },

    methods: {
        async getTotalEmployee () {
            this.show = false
            const url = `dashboard/getTotalEmployeeCheckInForGraph?branch=${this.branchId}`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.presentData = res.data.data.presentData
                this.lateData = res.data.data.lateData
                this.show = true
            }
        },

        async getBranch () {
            this.branchId = localStorage.getItem('currentBranchId')
            if (this.branchId) {
                await this.getTotalEmployee()
            }
        },

        initializeBarData () {
            this.show = true
            return {
                labels: this.days,
                datasets: [
                    {
                        label: this.$vuetify.lang.t('$vuetify.totalEmployeeGraph.present'),
                        backgroundColor: '#ead2ac',
                        borderColor: '#ead2ac',
                        fill: false,
                        data: this.presentData,

                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    type: 'string'
                                }]
                            }
                        }
                    },
                    {
                        label: this.$vuetify.lang.t('$vuetify.totalEmployeeGraph.late'),
                        backgroundColor: '#d76436',
                        borderColor: '#d76436',
                        fill: false,
                        data: this.lateData,

                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    type: 'string'
                                }]
                            }
                        }
                    }
                ]
            }
        }
    },

    async mounted () {
        await this.getBranch()
        this.initializeBarData()
    },

    watch: {
        '$store.state.currentBranchId': async function (newValue) {
            if (newValue) {
                this.branchId = newValue
                await this.getTotalEmployee()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.total-employee {
    border-radius: 15px;
    box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
}
.header-total-employee {
    height: 66px;
    font-size: 24px;
}
</style>
